import solver from 'solver-utilities';
import { TYPES } from './types.js';

let resizeTimeout = null;
let subnavTimeout = null;

/**
 * Sets header scroll limit
 **/
export const setHeaderLimit = function () {
	const root = document.querySelector(':root');
	const header = document.querySelector('header');
	const limit = parseInt(solver.frontend.getCSSVariable('--mega-menu-scroll-limit'));

	if (!header) return;
	const bottom = header.getBoundingClientRect().bottom;

	if (limit > bottom) root.style.setProperty('--mega-menu-scroll-limit', bottom + 'px');
};

/**
 * Sets header height to root property
 * @return header height
 **/
export const setHeaderHeight = function () {
	const root = document.querySelector(':root');
	const header = document.querySelector('header');
	const notificationBar = document.querySelector('.notification-bar');

	if (!header) return;

	const headerHeight = header.getBoundingClientRect().height;
	root.style.setProperty('--mega-menu-height', headerHeight + 'px');

	if (!notificationBar) return;
	const notificationBarHeight = notificationBar.getBoundingClientRect().height;
	root.style.setProperty('--notification-height', notificationBarHeight + 'px');

	return headerHeight;
};

/**
 * Sets the logo of the header depending on its
 * scroll position and viewport width
 **/
export const toggleHeaderLogo = function () {
	const header = document.querySelector('header');
	const limit = parseInt(solver.frontend.getCSSVariable('--mega-menu-height'));
	const logo = document.querySelector('[data-el="logo"]');

	if (window.innerWidth >= 1100 && window.scrollY < limit) {
		header.classList.remove('mega-menu--reduced');
		logo.classList.remove('menu__logo--logo-switch');
		return;
	}

	if (window.innerWidth >= 1100 && window.scrollY >= limit) {
		header.classList.add('mega-menu--reduced');
		logo.classList.add('menu__logo--logo-switch');
		return;
	}

	header.classList.remove('mega-menu--reduced');
	logo.classList.remove('menu__logo--logo-switch');
};

/**
 * Sets header scroll Y position
 **/
export const setHeaderScrollYPosition = function () {
	const header = document.querySelector('header');
	const limit = parseInt(solver.frontend.getCSSVariable('--notification-height'));
	const notificationBar = document.querySelector('.notification-bar');
	const notificationBounds = notificationBar.getBoundingClientRect();
	const notificationBarHeight = notificationBounds.height;
	const notificationYPos = notificationBounds.y;

	if (window.innerWidth >= 1100 && window.scrollY < limit) {
		const diff = notificationYPos + limit;
		header.style.top = notificationYPos + limit + 'px';
		return;
	}

	if (window.innerWidth >= 1100 && window.scrollY >= limit) {
		header.style.top = '0px';
		return;
	}

	header.removeAttribute('style');
};

/**
 * Sets the position value on scroll
 **/

const menu = {
	close: function () {
		const parentnavs = document.querySelectorAll('[data-el="mega-menu"] [data-parent-nav]');
		parentnavs.forEach((nav) => nav.classList.remove('menu-main__item--active'));

		const subnavs = document.querySelectorAll('[data-el="mega-menu"] [data-sub-nav]');
		subnavs.forEach((nav) => nav.classList.remove('mega-menu-subnav--active'));
	},
	mouseover: function (event) {
		if (!event) return;

		const target = event.currentTarget;
		const id = target.getAttribute('data-parent-nav');
		const subnav = document.querySelector(`[data-el="mega-menu"] [data-sub-nav="${id}"]`);

		if (!subnav) return;

		if (subnavTimeout) clearTimeout(subnavTimeout);

		menu.close();

		target.classList.add('menu-main__item--active');
		subnav.classList.add('mega-menu-subnav--active');
	},
	mouseout: function (event) {
		if (!event) return;

		const target = event.currentTarget;
		const id = target.getAttribute('data-parent-nav');

		subnavTimeout = setTimeout(() => {
			menu.close();
			subnavTimeout = null;
		}, 1000);
	}
};

const submenu = {
	mouseover: function (event) {
		if (subnavTimeout) clearTimeout(subnavTimeout);
	},
	mouseout: function (event) {
		if (!event) return;
		const target = event.currentTarget;
		const id = target.getAttribute('data-sub-nav');
		subnavTimeout = setTimeout(() => {
			menu.close();
			subnavTimeout = null;
		}, 300);
	}
};

export const mobile = {
	toggle: function (event, target) {
		if (event) {
			event.preventDefault();

			event.currentTarget.classList.toggle('mega-menu__mobile-menu-toggle--active');
		}

		const menu = document.querySelector('[data-el="mobile-menu"]');

		if (menu.className.indexOf('mobile-menu--active') === -1) {
			document.body.classList.add('overflow-hidden', 'mobile-menu-active');

			setHeaderHeight();

			menu.classList.add('mobile-menu--active');
			return;
		}

		menu.classList.remove('mobile-menu--active');
		document.body.classList.remove('overflow-hidden', 'mobile-menu-active');

		setHeaderHeight();
	},
	close: function () {
		const btn = document.querySelector('[data-el="mobile-menu-btn"]');
		btn.classList.toggle('mega-menu__mobile-menu-toggle--active');

		const menu = document.querySelector('[data-el="mobile-menu"]');
		menu.classList.remove('mobile-menu--active', 'mobile-menu-active');

		const set = document.querySelector('[data-active-set]');
		set.setAttribute('data-active-set', '0');

		const linksSet = document.querySelectorAll(`[data-links-set]`);
		linksSet.forEach((ul) => ul.classList.remove('active'));

		setHeaderHeight();
	},
	submenu: function (event, index) {
		setHeaderHeight();

		if (event) event.preventDefault();

		const wrapper = document.querySelector('[data-active-set]');
		const target = event.currentTarget;
		const set = target.getAttribute('data-set');

		const setContainer = document.querySelector(`[data-links="${index}"]`);
		const linksSet = setContainer.querySelectorAll(`[data-links-set]`);

		linksSet.forEach((ul) => {
			const links = ul.getAttribute('data-links-set');

			if (links == set) {
				ul.classList.add('active');
			} else {
				ul.classList.remove('active');
			}
		});

		wrapper.setAttribute('data-active-set', index);
	}
};

export const header = function () {
	document.body.classList.add('mega-menu--loaded');
	const mobileMenu = document.querySelector('[data-el="mobile-menu"]');
	setHeaderLimit(); //<!-- Must be first for additional scroll functions to operate correctly
	setHeaderHeight();
	toggleHeaderLogo();
	setHeaderScrollYPosition();

	window.Solver.openMenu = menu.mouseover;
	window.Solver.closeMenu = menu.mouseout;
	window.Solver.openSubmenu = submenu.mouseover;
	window.Solver.closeSubmenu = submenu.mouseout;
	window.Solver.toggleMobileMenu = mobile.toggle;
	window.Solver.toggleSubmenu = mobile.submenu;

	if (mobileMenu) {
		window.addEventListener('resize', () => {
			if (resizeTimeout) clearTimeout(resizeTimeout);

			mobileMenu.classList.add('mobile-menu--resizing');

			resizeTimeout = setTimeout(() => {
				clearTimeout(resizeTimeout);
				resizeTimeout = null;

				mobileMenu.classList.remove('mobile-menu--resizing');
			}, 500);
		});
	}

	const btn = document.querySelector('[data-el="mobile-menu-dropdown-btn"]');
	if (!btn) return;
	btn.click();
};
